import script from "./ProductLinkName.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ProductLinkName.vue?vue&type=script&lang=js"
export * from "./ProductLinkName.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ProductLinkName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-affiliate-link-card/ProductLinkName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2b25f6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2b25f6e', __exports__)) {
    api.reload('c2b25f6e', __exports__)
  }
  
}


export default __exports__